const FIRMS_PATH = "/firms";

export { FIRMS_PATH };
